import { z } from 'zod';

export const companyNameSchema = z.object({
  companyName: z
    .string()
    .min(1, 'Nazwa firmy jest wymagana')
    .max(255, 'Nazwa firmy może mieć maksymalnie 255 znaków'),
});

export type CompanyNameFormData = z.infer<typeof companyNameSchema>;
